import React, { ReactNode } from 'react';

interface ModuleWrapperProps {
  title: string;
  children: ReactNode;
}

export const ModuleWrapper: React.FC<ModuleWrapperProps> = ({ title, children }) => {
  return (
    <div className="w-full bg-white rounded-xl overflow-hidden border border-blue-100 mb-6">
      <div className="px-5 py-3 border-b border-blue-100">
        <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
      </div>
      <div className="bg-[#F5F9FF] ">{children}</div>
    </div>
  );
};
